import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHardHat } from '@fortawesome/pro-regular-svg-icons';
import { UserContext } from '../providers/UserProvider';
import { signOut } from '../firebase';

const AppLocked = ({ message, loading }) => {
  const { user } = useContext(UserContext);

  const bodyText =
    typeof message === 'string' && message.trim()
      ? message.trim()
      : 'We are updating the application. Please check back soon.';

  return (
    <Paper>
      <Grid container spacing={2} style={{ padding: '24px' }}>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <FontAwesomeIcon size='6x' icon={faHardHat} color='#c45500' />
        </Grid>
        <Grid item xs={12}>
          <Typography variant='h4' align='center' gutterBottom>
            Work in progress
          </Typography>
          <Typography variant='subtitle1' align='center' color='text.secondary'>
            This application is temporarily unavailable.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box
            minHeight='4.5rem'
            display='flex'
            alignItems='center'
            justifyContent='center'
          >
            {loading ? (
              <CircularProgress />
            ) : (
              <Typography variant='body1' align='center'>
                {bodyText}
              </Typography>
            )}
          </Box>
        </Grid>
        {user?.email ? (
          <Grid item xs={12}>
            <Typography variant='caption' display='block' align='center'>
              Signed in as {user.email}
            </Typography>
          </Grid>
        ) : null}
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Button
            type='button'
            variant='contained'
            onClick={() => {
              signOut();
            }}
          >
            Sign out
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

AppLocked.propTypes = {
  message: PropTypes.string,
  loading: PropTypes.bool
};

AppLocked.defaultProps = {
  message: '',
  loading: false
};

export default AppLocked;
